import React from "react";
import { Box } from "@mui/material";
import RevSelection from "../InputData/RevSelection";
import ModelingTabs from "./ModelingTabs";

export default function ModelingPanel() {
  return (
    <Box sx={{ backgroundColor: "var(--app-surface)", p: 1 }}>
      <Box sx={{}}>
        <RevSelection />
        <ModelingTabs />
      </Box>
    </Box>
  );
}
